<template>
  <div class="eq-layout">
    <Navbar :unread-count="unreadCount" />
    <div class="eq-layout__page">
      <AppMain />
    </div>
  </div>
</template>

<script>
import { getSysNoticeUnReadNum } from '@/api/api'
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'

export default {
  name: 'Layout',
  components: { AppMain, Navbar },
  data () {
    return { unreadCount: 0 }
  },
  created () {
    this.fetchUnreadCount()
    this.$root.$on('notice:refreshUnread', this.fetchUnreadCount)
  },
  beforeDestroy () {
    this.$root.$off('notice:refreshUnread', this.fetchUnreadCount)
  },
  methods: {
    async fetchUnreadCount () {
      try {
        const res = await getSysNoticeUnReadNum()
        this.unreadCount = Number(res.data || 0)
      } catch (error) {
        this.unreadCount = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eq-layout { min-height: 100vh; background: #f5f7fa; }
.eq-layout__page { padding: 76px 20px 20px; width: 95%; margin: 0 auto; overflow-x: hidden; }
</style>
